﻿$.fn.dxCtrlGridSmsEnvoi = function custom_dxCtrlGridSmsEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridsmsenvoi dx-ctrl");
        this.createInstance(new cdxCtrlGridSmsEnvoi(this, option));
    }
    return this;
}

window.cdxCtrlGridSmsEnvoi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var _disableUpdateFunction = false
    option.bddCtrl.mAddFunctionOnModifiedItemData(["com_sms_envoi"], container,
        function (action, itemData) {
            if (_disableUpdateFunction) {
                _disableUpdateFunction = false
                return
            }
            if (typeof itemData != 'undefined') {
                dxGrid.mUpdateData(action, option.bddCtrl.table.mGetItemFromNom("com_sms_envoi").id_table, itemData.id_com_sms_envoi)
            } else {
                dxGrid.mUpdateData()
            }
        })

    var dxGrid = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        //indefini = 0
        //boite_reception = 1
        //archive = 2
        //spam = 3
        //liste_grise = 4
        //non_delivre = 5
        //reponse_auto = 6
        //envoi_brouillon = 7
        //envoi_attente = 8
        //envoi_encours = 9
        //envoi_envoye = 10
        //envoi_erreur = 11
        //envoi_tracking = 12
        //envoi_attente_immediat = 13
        //envoi_annule = 14
        var noDataText = "Aucun sms envoyé"
        if (typeof option.lstIdTypeClassement != 'undefined') {
            noDataText = ""
            option.lstIdTypeClassement.forEach(function (idTypeClassement) {
                if (option.lstIdTypeClassement.length < 3) {
                    switch (parseInt(idTypeClassement)) {
                        case 7: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun sms brouillon"; break; //brouillon
                        case 8: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun sms en attente"; break; //brouillon
                        case 9: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun sms en cours d'envoi"; break; //en cours d'envoi
                        case 10: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun sms envoyé"; break; //en cours d'envoi
                        case 11: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun sms en erreur"; break; //en cours d'envoi
                        case 12: noDataText += ((noDataText.length > 0) ? "<br/>" : "") + "Aucun sms en tracking"; break; //tracking
                    }
                }
            })
            if (noDataText.length == 0) noDataText = "Aucun sms envoyé"
        }

        var typeData = ""
        if (typeof option.lstIdTypeClassement != 'undefined' && option.lstIdTypeClassement.contains(7)) {
            //brouillon
            typeData = "smsenvoibrouillon"
            if (typeof option.context_grid == 'undefined') option.context_grid = "gridsmsenvoibrouillon"
        } else {
            //envoye
            typeData = "smsenvoienvoye"
            if (typeof option.context_grid == 'undefined') option.context_grid = "gridsmsenvoienvoye"
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid({
            bddCtrl: option.bddCtrl,
            noDataText: noDataText,
            typeData: typeData,
            lstLstConditionBase: mGetLstLstConditionBase(),
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            lstTypeGrille: ["Détails", "Lignes"],
            fields: mGetLstField(),
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: true,
            itemTemplateGrille: function (container, dataTemplate, type, optionTemplate) {
                var objBase = null
                if (dataTemplate.id_table_key == 0) {
                    objBase = new cObjetFile(dataTemplate, option.bddCtrl)
                } else {
                    objBase = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataTemplate.id_table_key).nom) //, option.dataTemplateDisplay.id_key)
                }
                objBase.itemTemplateGrille(container, dataTemplate, type)

                getClasseurDataTournee({ bddCtrl: option.bddCtrl }).mInitDragClasseur(container.closest(".divtemplate"), dxGrid, "com_sms_envoi", "", optionTemplate.dataGrid, function (lstElementDataGrid, toSousType) {
                })
            }
        }).dxCtrlVirtualGrid("instance")
    }

    function mGetLstField() {
        var lst = []
        if (typeof option.lstIdTypeClassement != 'undefined' && option.lstIdTypeClassement.contains(7)) {
            lst = lst.concat([{
                name: "dcr",
                dataField: "dcr",
                caption: "Date création",
                icon: "fas fa-clock",
                allowFilter: true,
                allowGrid: true,
                allowGrouping: true,
                allowSorting: true,
                groupIndex: 0,
                sortOrder: "desc",
                dataType: "date",
                filterProperty: {
                    filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
                },
                calculateGroupValue: function (rowData) {
                    return rowData.dcr.toGrpDate().id
                },
                groupCellTemplate: function (columnElement, options) {
                    var tot = 0
                    options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                    columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Création: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
                },
                filterLinkGrp: "dcr_tri"
            }, {
                name: "dcr_tri",
                dataField: "dcr_tri",
                allowGrid: true,
                visible: false
            }])
        } else {
            lst = lst.concat([{
                name: "date_envoi",
                dataField: "date_envoi",
                caption: "Date d'envoi",
                icon: "fas fa-clock",
                allowFilter: true,
                allowGrid: true,
                allowGrouping: true,
                allowSorting: true,
                groupIndex: 0,
                sortOrder: "desc",
                dataType: "date",
                filterProperty: {
                    filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
                },
                calculateGroupValue: function (rowData) {
                    return rowData.date_envoi.toGrpDate().id
                },
                groupCellTemplate: function (columnElement, options) {
                    var tot = 0
                    options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                    columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Date envoi: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
                },
                filterLinkGrp: "date_envoi_tri"
            }, {
                name: "date_envoi_tri",
                dataField: "date_envoi_tri",
                allowGrid: true,
                visible: false
            }])
        }
        lst = lst.concat([{
            name: "id_utilisateur",
            dataField: "id_utilisateur",
            caption: "Utilisateur",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = options.data.key
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-user dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + txt + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.id_utilisateur
            },
            calculateSortValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            filterProperty: {
                lookup: option.bddCtrl.getObjet("utilisateur").objetMetier.mGetLookUpForFilterBuilder(),
                filterOperations: ["parmi", "notparmi"]
            }
        }, {
            name: "body_txt",
            dataField: "body_txt",
            caption: "Corps du mail",
            allowFilter: true,
            allowGrid: false,
            dataType: "string"
        }])
        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-comment-sms",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            txtTooltip: "Nouveau sms",
            //            onClick: function (e) {
            //                option.bddCtrl.getObjet("com_sms_envoi").objetMetier.mShowNewSms()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
        }
        //items.push({
        //    location: 'before',
        //    template: function (itemData, itemIndex, itemElement) {
        //        dxBtNewDocEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
        //            icon: "fas fa-bars",
        //            onClick: function (e) {
        //                mShowBtPlus(e.component.element())
        //            }
        //        }).dxCtrlButton("instance")
        //    }
        //})

        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []

        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                icon: "fas fa-trash-alt",
                elementAttr: { class: "dx-button-grille-ligne" },
                focusStateEnabled: false,
                text: "Supprimer",
                hint: "Supprimer",
                onClick(e) {
                    e.event.stopPropagation();
                    dxGrid.mRemoveRow(dataGrid)
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    _disableUpdateFunction = true
                    obj.mDelData(function () { })
                }
            },
        })

        toolbar.option("items", items)
    }

    function mGetLstLstConditionBase() {
        var lstConditionBase = []
        if (typeof option.lstIdTypeClassement != 'undefined' && option.lstIdTypeClassement.length > 0) {
            var lstId = []
            option.lstIdTypeClassement.forEach(function (idTypeClassement) {
                lstId.push({ value: idTypeClassement })
            })
            lstConditionBase.push({ nom_champ: "id_type_classement", ope: "parmi", valeur: lstId })
        }
        return [lstConditionBase]
    }

    this.element = function () { return container }

    mConstruit();
}